import { render, staticRenderFns } from "./WalletRequired.vue?vue&type=template&id=5eb1336f&scoped=true"
import script from "./WalletRequired.vue?vue&type=script&lang=js"
export * from "./WalletRequired.vue?vue&type=script&lang=js"
import style0 from "./WalletRequired.vue?vue&type=style&index=0&id=5eb1336f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb1336f",
  null
  
)

export default component.exports